import { render } from "./MembershipForm.vue?vue&type=template&id=b826fca4"
import script from "./MembershipForm.vue?vue&type=script&lang=js"
export * from "./MembershipForm.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\SPNM\\Core\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__